export default __webpack_public_path__ + "static/media/jewelry-bright-spring.2108d7f1.png";